import styled from "styled-components";

export const GroupFiltersListContainerFilterByBox = styled.span`
  font-size: 11px;
  margin-bottom: 20px;
  display: block;
  color: ${props => props.theme.colors.text};
`;